export default __webpack_public_path__ + "5500c9be25e8e95043dff799d8285dac.svg";